/** Un échange ping/pong : envoi et réception en horloge locale, `peerT` en horloge du pair. */
export interface ClockSample {
  readonly sentAt: number;
  readonly peerT: number;
  readonly receivedAt: number;
}

export interface ClockEstimate {
  /** horloge du pair − horloge locale (ms). */
  readonly offset: number;
  readonly rtt: number;
}

/**
 * Estimation type NTP : on suppose la latence symétrique et on garde l'échange
 * au plus petit aller-retour (celui où cette hypothèse est la moins fausse).
 */
export function estimateOffset(samples: readonly ClockSample[]): ClockEstimate | null {
  let best: ClockEstimate | null = null;
  for (const { sentAt, peerT, receivedAt } of samples) {
    const rtt = receivedAt - sentAt;
    if (![sentAt, peerT, receivedAt].every(Number.isFinite) || rtt < 0) continue;
    if (!best || rtt < best.rtt) best = { offset: peerT - (sentAt + receivedAt) / 2, rtt };
  }
  return best;
}

export const toLocalTime = (peerT: number, offset: number): number => peerT - offset;
